import React from 'react';
import { FormattedMessage } from 'react-intl';

export const installationStatusOptions = [{
    id: 'all',
    value: 'all',
    label: <FormattedMessage id='intl-msg:all'/>
}, {
    id: 'NOT_STARTED',
    value: 'NOT_STARTED',
    label: <FormattedMessage id='intl-msg:campaign:statistics:notStarted'/>
}, {
    id: 'SENT_TO_DEVICE',
    value: 'SENT_TO_DEVICE',
    label: <FormattedMessage id='intl-msg:campaign:statistics:sentToDevice'/>
}, {
    id: 'IN_PROGRESS',
    value: 'IN_PROGRESS',
    label: <FormattedMessage id='intl-msg:campaign:statistics:inProgress'/>
}, {
    id: 'UPDATED',
    value: 'UPDATED',
    label: <FormattedMessage id='intl-msg:campaign:statistics:updated'/>
}, {
    id: 'FAILED',
    value: 'FAILED',
    label: <FormattedMessage id='intl-msg:campaign:statistics:failed'/>
}, {
    id: 'REBOOT_PENDING',
    value: 'REBOOT_PENDING',
    label: <FormattedMessage id='intl-msg:campaign:statistics:rebootPending'/>
}];